import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'components/Dialog';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectRoomE2eeCode } from 'features/e2ee/e2eeSlice';
import { Box, Button } from '@mui/material';
import { closeModal } from 'features/modal/modalSlice';
import { useEffect, useId } from 'react';
import CopyButton from 'components/CopyButton/CopyButton';
import RoomE2EECode from 'components/RoomE2EECode';
import { useCopyButton } from 'components/CopyButton/useCopyButton';

const RoomSecurityCodeModal = () => {
  const { t } = useTranslation(['modals', 'settings']);
  const dispatch = useAppDispatch();

  const { copied, copyToClipboard, resetCopied } = useCopyButton();

  const prefix = useId();

  const roomCode = useAppSelector(selectRoomE2eeCode);

  useEffect(() => {
    resetCopied();
  }, [roomCode, resetCopied]);

  const handleOk = () => {
    dispatch(closeModal('roomE2eeCode'));
  };

  const handleClose = () => {
    dispatch(closeModal('roomE2eeCode'));
  };

  return (
    <Dialog
      open
      maxWidth="xs"
      onClose={handleClose}
      aria-labelledby={`${prefix}-title`}
      aria-describedby={`${prefix}-description`}
    >
      <DialogTitle id={`${prefix}-title`}>
        {t('settings:security.room_e2ee_code.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id={`${prefix}-description`}>
          {t('settings:security.room_e2ee_code.description')}
        </DialogContentText>
        <Box
          sx={{
            mt: 5,
          }}
        >
          <RoomE2EECode roomCode={roomCode} />
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: 'space-between',
        }}
      >
        <CopyButton
          copied={copied}
          onCopy={copyToClipboard}
          text={roomCode.join(' ')}
          sx={{
            color: 'inherit',
          }}
        >
          {(isCopied) =>
            isCopied
              ? t('settings:security.room_e2ee_code.btn_copied_label')
              : t('settings:security.room_e2ee_code.btn_copy_label')
          }
        </CopyButton>
        <Button onClick={handleOk} autoFocus>
          {t('room_e2ee_code.btn_ok_label')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RoomSecurityCodeModal;
